/**
 * BottomNav component — Brand Book §3.8
 * 56px height, fixed bottom, 4 items, mobile only
 * Replaces top nav tabs on screens <768px
 */

import { NavLink, useLocation } from 'react-router-dom';
import { Grid, Briefcase, Upload, Settings } from 'react-feather';
import { clsx } from 'clsx';

interface BottomNavItem {
  label: string;
  href: string;
  icon: React.ReactNode;
}

const items: BottomNavItem[] = [
  { label: 'Dashboard', href: '/dashboard', icon: <Grid size={20} /> },
  { label: 'Deals', href: '/deals', icon: <Briefcase size={20} /> },
  { label: 'Upload', href: '/upload', icon: <Upload size={20} /> },
  { label: 'Settings', href: '/settings', icon: <Settings size={20} /> },
];

export function BottomNav() {
  const { pathname } = useLocation();

  // Mobile is locked to /chat + /settings (see MobileChatGate). On both
  // routes the BottomNav would only show tabs (Dashboard / Deals / Upload)
  // that bounce back to /chat — so suppress it entirely. The md:hidden on
  // the nav element below already handles desktop.
  if (pathname === '/chat' || pathname === '/settings') {return null;}

  return (
    <nav
      className={clsx(
        'fixed bottom-0 left-0 right-0 z-40',
        'h-14 bg-surface-card border-t border-border',
        'flex items-center justify-around',
        'md:hidden' // Only visible on mobile
      )}
    >
      {items.map((item) => (
        <NavLink
          key={item.href}
          to={item.href}
          className={({ isActive }) =>
            clsx(
              'flex flex-col items-center justify-center gap-0.5',
              'w-full h-full min-w-[44px]', // 44px touch target
              'transition-colors duration-200',
              isActive ? 'text-orange' : 'text-txt-tertiary'
            )
          }
        >
          {item.icon}
          <span className="text-caption">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
